<div class="card">
  <div class="row">
    <div class="col-12 col-md-6">
      <category-tree
        [disabled]="!productDetailService.hasUpdateRole"
        [categoryTreeLabel]="'product.tab.categories.mainCategory'"
        [type]="categoryTreeTypeEnum.radioProductMainCategory"
        [categories]="categories"
        [(mainCategory)]="product.mainCategory"
      ></category-tree>
    </div>
    <div class="col-12 col-md-6">
      <category-tree
        [disabled]="!productDetailService.hasUpdateRole"
        [categoryTreeLabel]="'product.tab.categories.categories'"
        [type]="categoryTreeTypeEnum.checkboxProductCategories"
        [categories]="categories"
        [(selectedCategories)]="product.categories"
      ></category-tree>
    </div>
    <div class="col-12" *ngIf="!isCreating && !loading && (!categories || (categories && !categories.length))">
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <p class="m-0">
            {{'product-categories.no-category.1' | translate}}
            <a [routerLink]="['/categories']">{{'product-categories.no-category.2' | translate}}</a>.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
